import { render, staticRenderFns } from "./obligationsForm.vue?vue&type=template&id=25109b14&"
import script from "./obligationsForm.vue?vue&type=script&lang=js&"
export * from "./obligationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports